'use client'
import React, { useState } from "react";
import TimerWorkerClass from "./TimerWorkerClass";
import { TIMER_ACTIONS } from "./TimerConstants";

export default class TimerController extends React.Component {
    protected timerWorker;

  constructor({...props}) {
    super(props);
    
    this.state = {timerId: props?.timerId};
    this.onSaveHandler = this.onSaveHandler.bind(this);
    this.timerOnMessageHandler = this.timerOnMessageHandler.bind(this);
  }

    componentDidMount =() =>  {
        //this.notifyMe();
 //this.createTimer();
    window.addEventListener('unload', () => this.closeWorker())  
          
    }

      closeWorker () {
    this.timerWorker.terminate()
    //this.setWebSocketStatus(false)
  }

  createTimer() {
    this.timerWorker = new TimerWorkerClass({
      func: this.timerOnMessageHandler,
      ctx: this
    })
    this.timerWorker.postMessage({
      action: TIMER_ACTIONS.START_TIMER,
      payload: {
        //url: process.env.REACT_APP_WS_ENDPOINT
      }
    })
  }

    timerOnMessageHandler (timerData) {
        const timerId = this.props['timerId'];
console.debug("TIMER DATA "+timerId, timerData);
    }


    onSaveHandler(event) {
        event.preventDefault();
        event.stopPropagation();

        return false;
    }

  render() {
    return <></>


  }


}